import { useRef, useState, type DragEvent } from 'react';

/** File drops are separate from pointer dragging used to position a goods image. */
export function useImageFileDrop(disabled: boolean, onFile: (file: File) => void) {
  const depth = useRef(0);
  const [over, setOver] = useState(false);
  const isFile = (event: DragEvent<HTMLElement>) =>
    Array.from(event.dataTransfer.types).includes('Files');
  return {
    isFileOver: over && !disabled,
    dropHandlers: {
      onDragEnter(event: DragEvent<HTMLElement>) {
        if (!isFile(event)) return;
        event.preventDefault();
        depth.current += 1;
        if (!disabled) setOver(true);
      },
      onDragOver(event: DragEvent<HTMLElement>) {
        if (!isFile(event)) return;
        event.preventDefault();
        event.dataTransfer.dropEffect = disabled ? 'none' : 'copy';
      },
      onDragLeave(event: DragEvent<HTMLElement>) {
        if (!isFile(event)) return;
        depth.current = Math.max(0, depth.current - 1);
        if (!depth.current) setOver(false);
      },
      onDrop(event: DragEvent<HTMLElement>) {
        if (!isFile(event)) return;
        event.preventDefault();
        event.stopPropagation();
        depth.current = 0;
        setOver(false);
        const file = event.dataTransfer.files[0];
        if (!disabled && file) onFile(file);
      },
    },
  };
}
